import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const emailSlice = createSlice({
  name: "emailSlice",
  initialState: {
    loading: false,
    emailList: [],
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    getEmails: (state, action) => {
      state.emailList = action.payload;
    },
  },
});

export const { getEmails, loading } = emailSlice.actions;

export const sendEmail = (emailData, handleClear) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/send_subscription_mail`;
    const { data } = await axios.post(url, emailData, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(loading(false));
    handleClear();
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const getEmailHistory = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_subscription_emails`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(getEmails(data?.data));
    dispatch(loading(false));
  } catch (error) {
    dispatch(loading(false));
    errorHandling(error);
  }
};

export default emailSlice.reducer;
